export default __webpack_public_path__ + "static/media/alteredu.a3956faa.png";